import { FormEvent, ReactNode } from 'react';
import { Box } from '@mui/material';
import styles from './AuthFormWrapper.module.css';

interface AuthFormWrapperProps {
	onSubmit: (e: FormEvent) => void | Promise<void>;
	children: ReactNode;
	socialButtons?: ReactNode;
	showDivider?: boolean;
}

export const AuthFormWrapper = ({
	onSubmit,
	children,
	socialButtons,
	showDivider = true,
}: AuthFormWrapperProps) => {
	return (
		<Box className={styles.container}>
			<form className={styles.form} onSubmit={onSubmit}>
				{children}
			</form>

			{socialButtons && (
				<>
					{showDivider && (
						<Box className={styles.divider}>
							<Box className={styles.line} />
							<span className={styles.dividerText}>OU</span>
							<Box className={styles.line} />
						</Box>
					)}

					<Box className={styles.socialButtons}>{socialButtons}</Box>
				</>
			)}
		</Box>
	);
};
